import { createReducer, on } from '@ngrx/store';
import { EmployeeProfile } from '../../widgets/staar/models/employee-profile';
import { setCustomerEmployeeVNumber, setEmployee } from './users.actions';

export type ReducerState = {
  employees: Record<string, EmployeeProfile>;
  customerEmployeeVNumber: string;
};

const initialState: ReducerState = {
  employees: {},
  customerEmployeeVNumber: ''
};

const _usersReducer = createReducer<ReducerState>(
  initialState,
  on(setEmployee, (state, { employee }) => {
    const employeeNumber = employee.EMPLOYEE_NUMBER;
    const employees = { ...state.employees };
    employees[employeeNumber] = employee;
    return { ...state, employees };
  }),
  on(setCustomerEmployeeVNumber, (state, { vNumber }) => ({ ...state, customerEmployeeVNumber: vNumber})),
);

export const usersReducer = (state, action) => _usersReducer(state, action);
